import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b3c8dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__wrapper__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "k-icon k-i-close" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "modal__wrapper__body" }
const _hoisted_5 = { class: "modal__wrapper__footer" }

import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'IModal',
  emits: ["close"],
  setup(__props, { emit }) {


const closeModal = (): void => {
  emit('close');
}

const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: closeModal
  }, [
    _createElementVNode("div", {
      class: "modal__wrapper",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _createElementVNode("div", {
          class: "modal__close",
          onClick: closeModal
        }, _hoisted_3)
      ]),
      _createElementVNode("section", _hoisted_4, [
        _renderSlot(_ctx.$slots, "body")
      ]),
      _createElementVNode("footer", _hoisted_5, [
        _renderSlot(_ctx.$slots, "footer")
      ])
    ])
  ]))
}
}

})